import { render, staticRenderFns } from "./HomeCollections.vue?vue&type=template&id=303092c6&scoped=true&"
import script from "./HomeCollections.vue?vue&type=script&lang=js&"
export * from "./HomeCollections.vue?vue&type=script&lang=js&"
import style0 from "./HomeCollections.vue?vue&type=style&index=0&id=303092c6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303092c6",
  null
  
)

export default component.exports